const BASE_URL = '/api/item/redirect'

export interface RedirectAPIResponse {
  itemId: string
}

export const useItemRedirect = () => {
  const { fetchGet } = useCustomFetch()

  const getItemRedirect = async (issToken: string): Promise<RedirectAPIResponse> => {
    return await fetchGet(BASE_URL + `?issToken=${issToken}`)
  }

  return {
    getItemRedirect,
  }

}
